<ng-container>
    <div class="page-content">
      @if(spinBool){
        <div class="spinner-overlay">
          <owc-progress-spinner size="xxLarge" value="50" />
        </div>
      }
      <div class="cn-notification-container" style="display: flex; flex-direction: column;">
        <owc-card class="notification-list" style="box-shadow: none;">
          <div>
            <div class="notification-list-title">
              Notifications overview
            </div>
            <div class="notification-search-rows">
                <dl-notification-search (searchValue)="searchValueInp($event)">
                </dl-notification-search>
            </div>
          </div>

          <div style="margin-block: 1%;">
              <dl-notification-filter  [filterOptions]="filterOptions" 
              (filterOptEmit)="filterOptInp($event)">
             </dl-notification-filter>
          </div>
        </owc-card>
    
          <dl-notification-table  
            [tableData]="notificationsList" 
            [filterOptSel]="filterOptSel" 
            [searchValueSel]="searchValueSel"
            (filterOptionsExtracted)="updateFilterOptions($event)">
          </dl-notification-table>
        
      </div>
    </div>
</ng-container>

